export const mortgageLeanModule = {
    namespaced: true,
    state: {
        publicMortgage: null,
        recommendedValues: null,
        proposals: null,
        total: null,
        errors: null
    },
    mutations: {
      SET_PUBLIC_MORTGAGE: (state, loan) => {
        state.publicMortgage = loan
      },
      SET_PUBLIC_MORTGAGE_TOTAL: (state, total) => {
        state.total = total
      },
      SET_PROPOSALS: (state, proposals) => {
        state.proposals = proposals
      },
      CLEAR_ALL: (state) => {
        state.publicMortgage = null
        state.porposals = null
      },
      SET_RECOMMENDED_VALUES: (state, values) => {
        state.recommendedValues = values
      },
      SET_ERRORS: (state, errors) => {
        state.errors = errors
      }
    },
    getters: {
      all: state => {
        return state
      },
      publicMortgage: state => {
        return state.publicMortgage
      },
      publicMortgageTotal: state => {
        return state.total
      },
      recommendedValues: state => {
        return state.recommendedValues
      },
      errors: state => {
        return state.errors
      },
      proposals: state => {
        return state.proposals
      },
    },
    actions: {
      clearAll (ctx) {
        ctx.commit('CLEAR_ALL')
      }
    }
  }
  